<template>
  <div class="active-column flex-1">
    <div class="flex items-center justify-between mb-3">
      <h2 class="font-headline text-title-md text-primary">Active Now</h2>
      <Button
        variant="ghost"
        size="small"
        class="text-secondary hover:text-secondary-container text-sm"
        @click="$emit('view-all')"
      >
        View All ({{ users.length }})
        <ChevronRight class="ml-1 h-4 w-4" />
      </Button>
    </div>
    <div v-if="error">
      <ErrorDisplay :message="error" />
    </div>
    <div
      class="flex space-x-3 overflow-x-auto pb-2 -mx-1 px-1 md:grid md:grid-cols-5 md:gap-3 md:overflow-visible md:mx-0 md:px-0"
    >
      <div
        v-for="user in users.slice(0, 5)"
        :key="user.id"
        class="flex-shrink-0 w-16 text-center cursor-pointer md:w-auto"
        @click="$emit('open', user.id)"
      >
        <div
          class="relative mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary-container ring-2 ring-surface-container-high"
        >
          <div class="w-full h-full rounded-full overflow-hidden">
            <img
              v-if="getUserPhoto(user)"
              :src="getUserPhoto(user)"
              alt="Profile Photo"
              class="w-full h-full object-cover"
            >
            <User v-else class="h-6 w-6 text-on-primary-container" />
          </div>
          <div
            class="absolute -bottom-1 -right-1 h-4 w-4 rounded-full border-2 border-surface-container-lowest bg-secondary-container"
          />
        </div>
        <p class="truncate font-body text-body-xs text-on-surface-variant">
          {{ user.name || 'Camper' }}
        </p>
      </div>
      <div
        v-if="users.length > 5"
        class="flex-shrink-0 w-16 text-center cursor-pointer md:w-auto"
        @click="$emit('view-all')"
      >
        <div
          class="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full border-2 border-dashed border-outline-variant bg-surface-container-high"
        >
          <span class="font-label text-label-sm text-on-surface-variant">+{{ users.length - 5 }}</span>
        </div>
        <p class="font-body text-body-xs text-on-surface-variant">more</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ChevronRight, User } from 'lucide-vue-next'
import Button from '../ui/Button.vue'
import ErrorDisplay from '../ui/ErrorDisplay.vue'
import { getAvatarImage } from '../../lib/imageUtils'

const props = defineProps({
  users: {
    type: Array,
    default: () => []
  },
  error: {
    type: String,
    default: ''
  }
})

defineEmits(['open', 'view-all'])

function getUserPhoto(user) {
  let originalUrl

  if (user.thumbnail_url) {
    originalUrl = user.thumbnail_url
  } else {
    const primary = user.profile_photos?.find(p => p.is_thumbnail)
    if (primary) {
      originalUrl = primary.photo_url
    } else {
      originalUrl = user.profile_photos?.[0]?.photo_url || null
    }
  }

  // Apply avatar-sized optimization (48x48px)
  return originalUrl ? getAvatarImage(originalUrl) : null
}
</script>
